(() => {
  // app/scripts/common/section/article-page.js
  var ArticlePage = {
    onLoad: function() {
      let { container } = this;
      let sliderContainer = container.querySelector(".js-slider-container");
      let config = JSON.parse(sliderContainer.querySelector("[data-tns-config]").innerHTML);
      config.onInit = () => {
        sliderContainer.addClass("slider-initialized");
      };
      tns(config);
      let collapseButtons = document.querySelectorAll("#sidebarDrawer .js-btn-collapse");
      collapseButtons.forEach((button) => {
        let target = button.nextElementSibling;
        button.addEvent("click", function() {
          if (this.hasClass("is-open")) {
            this.removeClass("is-open");
            target.removeClass("is-open");
          } else {
            this.addClass("is-open");
            target.addClass("is-open");
          }
        });
      });
    }
  };

  // app/scripts/article-page.js
  (() => {
    register("article-page", ArticlePage);
    load("*");
  })();
})();
